module.exports = __webpack_public_path__ + "static/img/5.03b2285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/5.png
// module id = 2y4c
// module chunks = 2